import biblical from "./biblicalback.jpg";

const obj = {
  biblical,
};

export default obj;
